<template>
    <div class="auction-detail-bid__block">
        <div class="auction-detail-bid__block-label">Всего ставок</div>

        <div class="auction-detail-bid__block-value">
            <span>{{ auction.broadcastInfo?.bids_count ?? auction.bids_count }}</span>

            <span
                v-if="isAdmin() && (auction.broadcastInfo?.bids_count ?? auction.bids_count) > 0"
                class="img"
                :class="{ rotate: !opened }"
                @click.stop="emit('toggleBids')"
            >
                <img v-svg-inline src="@/assets/icons/ui/arrow-temp.svg" />
            </span>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { PropType } from 'vue';

    import { Auction } from '@/types/auction.type.ts';

    import usePermission from '@/repositories/auth/usePermission.ts';

    const { auction, opened } = defineProps({
        auction: {
            type: Object as PropType<Auction>,
            required: true,
        },
        opened: {
            type: Boolean,
            default: false,
        },
    });

    const { isAdmin } = usePermission();

    const emit = defineEmits<{
        (e: 'toggleBids'): void,
    }>();
</script>
